<po-page-default p-title="Novas Vendas"
  p-subtitle="Acompanhe suas novas vendas e exporte os dados em formato de relatório." [p-breadcrumb]="breadcrumbItems">


</po-page-default>